import polymer_products from "../../assets/Clients/cli_1.webp";
import rajveer_bakery from "../../assets/Clients/cli_2.webp";
import lar_turb from "../../assets/Clients/cli_3.webp";
import polymax from "../../assets/Clients/cli_4.webp";
import sataac from "../../assets/Clients/cli_5.webp";
import ssab from "../../assets/Clients/cli_6.webp";

export const clients = [
  { name: "Polymer Products", img: polymer_products },
  { name: "Rajveer Bakery", img: rajveer_bakery },
  { name: "Larsen & Turbo", img: lar_turb },
  { name: "Polymax", img: polymax },
  { name: "SATAAC", img: sataac },
  { name: "SSAB", img: ssab },
];
